import { isPlainObject as b } from "../../../../../utils/value/is.js";
import { EMPTY_OBJECT as u } from "../../../../../utils/value/constants.js";
import { struct as a, structFrom as l } from "../../../../../utils/struct/main.js";
import { enumerable as m } from "../../../../../utils/struct/property.js";
import { boolOrTrue as O } from "../../../../../utils/value/bool.js";
const c = (() => {
  const s = (e) => Object.freeze(
    l(u, Object.fromEntries(Object.entries(e).map(([r, t]) => [r, { value: t }])))
  ), i = (e) => {
    try {
      return Object.getPrototypeOf(e) === u;
    } catch {
      return !1;
    }
  }, o = (e, r) => {
    if (!e) return s(m(r, O(e)));
    let t = r;
    return s({
      enumerable: !0,
      get: () => t,
      set: (n) => {
        t = e(n);
      }
    });
  };
  return Object.defineProperties(o, {
    is: { value: i },
    isObject: { value: b },
    immutable: { value: (e) => o(!1, e) },
    mutable: { value: (e) => o(void 0, e) },
    restricted: { value: () => o(!1) }
  });
})(), g = (() => {
  const s = (o = {}, e = !1) => {
    const r = a();
    for (const [t, n] of Object.entries(o)) {
      try {
        const p = c.is(n), f = c.isObject(n);
        if (p || f) {
          Object.defineProperty(r, t, p ? n : s(n, e));
          continue;
        } else if (e) {
          Object.defineProperty(r, t, c.immutable(n));
          continue;
        }
      } catch {
      }
      r[t] = n;
    }
    return c((t = {}) => Object.assign(r, t), r);
  };
  return Object.defineProperties(s, {
    unwrapped: { value: (o = {}, e = !1) => {
      const r = s(o, e);
      return a({ P: r }).P;
    } }
  });
})();
export {
  c as property,
  g as propsProperty
};
